import { LockClosedIcon } from "@heroicons/react/24/solid";
import { PlanUpgradeCTA } from "./plan-upgrade-cta";

type LockedOverlayProps = {
  title: string;
  description: string;
  withCta?: boolean;
};

/**
 * Blurred overlay with a lock icon shown over gated features on the mini/retraction plan.
 */
export function LockedOverlay({
  title,
  description,
  withCta,
}: LockedOverlayProps) {
  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center bg-background/70 backdrop-blur-[1.2px] px-6">
      <div className="flex flex-col items-center gap-3 rounded-xl border bg-background px-6 py-5 shadow-md text-center max-w-sm">
        <div className="flex h-9 w-9 items-center justify-center rounded-full bg-muted">
          <LockClosedIcon className="h-4 w-4 text-muted-foreground" />
        </div>
        <div className="space-y-1">
          <p className="text-sm font-semibold text-foreground">{title}</p>
          <p className="text-xs text-muted-foreground">{description}</p>
        </div>
        {withCta && <PlanUpgradeCTA />}
      </div>
    </div>
  );
}
